import { render, staticRenderFns } from "./ClientesPorcentagemQuantidade.vue?vue&type=template&id=38cc629e&scoped=true&"
import script from "./ClientesPorcentagemQuantidade.vue?vue&type=script&lang=js&"
export * from "./ClientesPorcentagemQuantidade.vue?vue&type=script&lang=js&"
import style0 from "./ClientesPorcentagemQuantidade.vue?vue&type=style&index=0&id=38cc629e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cc629e",
  null
  
)

export default component.exports